import { render, staticRenderFns } from "./order-management.vue?vue&type=template&id=3c7753b4&scoped=true&"
import script from "./order-management.vue?vue&type=script&lang=js&"
export * from "./order-management.vue?vue&type=script&lang=js&"
import style0 from "./order-management.vue?vue&type=style&index=0&id=3c7753b4&lang=scss&scoped=true&"
import style1 from "./order-management.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7753b4",
  null
  
)

export default component.exports